module.exports = __webpack_public_path__ + "static/media/COS_NUTRISENS.64216e15.png";